(ns frontend.controller.routing.event
  (:require
   [re-frame.core :as rf]
   [reitit.frontend.easy :as reitit-e]
   [reitit.frontend :as reitit]
   [reitit.frontend.controllers :as reitit-c]))

(defn on-navigate
  [new-match]
  (when new-match
    (rf/dispatch [::navigated new-match])))

(rf/reg-fx
 ::init-routes
 (fn [{:keys [routes] :as args}]
   (let [router (reitit/router routes)]
     (reitit-e/start!
      router
      on-navigate
      {:use-fragment false}))))

(rf/reg-event-fx
 ::initialize-routing
 (fn [_ [_ routes]]
   {::init-routes {:routes routes}}))

(rf/reg-event-db
 ::navigated
 (fn [db [_ new-match]]
   (let [old-match (:view-route db)
         controllers (reitit-c/apply-controllers (:controllers old-match) new-match)]
     (assoc db :view-route (assoc new-match :controllers controllers)))))

(rf/reg-fx
 ::push-state
 (fn [{:keys [handler path-params query-params] :as route}]
   (apply reitit-e/push-state [handler path-params query-params])))

(rf/reg-event-fx ::push-view-state
 (fn [_ [_ & route]]
   {::push-state route}))
